import { aFullProjectDocumentsList, aProjectDocumentsList } from '../../utils/fixtures';
export default class FakeDocumentTypeService {
  getDocumentTypesForProjectCreation() {
    return Promise.resolve(aProjectDocumentsList());
  }
  getDocumentTypesForProjectEdition() {
    return Promise.resolve(aFullProjectDocumentsList());
  }
}